<script>

	import './style.scss'

	export default {
		name: 'testimonials',
	}

</script>

<template>
	<div class='testimonials'>
		<header>
			<h1>
				Testimonials
			</h1>
		</header>
		<div class='container'>
			<div class='testimonial'>
				<!-- <img class='avatar' src='/static/avatars/placeholder-guy.jpg'> -->
				<div class='company'>
					<span class='name'>Aditya A.</span>
					<span class='slash'>+</span>
					<img src='/static/companies/microsoft.svg' class='microsoft' />
				</div>
				<p>
					I did my Microsoft onsite last week and just this morning I got a call
					from the recruiter saying I have the offer. Thank you TechInterviewClub!
				</p>
			</div>
			<div class='testimonial'>
				<!-- <img class='avatar' src='/static/avatars/placeholder-guy.jpg'> -->
				<div class='company'>
					<span class='name'>David J.</span>
					<span class='slash'>+</span>
					<img src='/static/companies/google.svg' class='google' />
				</div>
				<p>
					I was able to pass my Google interviews because I practiced all the
					recent Google questions from TechInterviewClub! It's honestly a great
					way to study because you know exactly what to expect from the real thing.
				</p>
			</div>
			<div class='testimonial'>
				<!-- <img class='avatar' src='/static/avatars/placeholder-guy.jpg'> -->
				<div class='company'>
					<span class='name'>John P.</span>
					<span class='slash'>+</span>
					<img src='/static/companies/amazon.svg' class='amazon' />
				</div>
				<p>
					I landed my job at Amazon after doing the Amazon questions in
					TechInterviewClub!
				</p>
			</div>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Testimonials/Testimonials.vue